import classnames from 'classnames';
import React, { FC } from 'react';

import './Switch.scss';

export enum SWITCH_SIZES {
  DEFAULT,
  SMALL,
}

export type Props = Partial<HTMLButtonElement> & {
  ariaLabel?: string;
  checked: boolean;
  label?: string | JSX.Element;
  onChange?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  size: SWITCH_SIZES;
  isPro?: boolean;
  defaultChecked?: boolean;
};

export const Switch: FC<Props> = ({
  className,
  name,
  id,
  onChange,
  checked,
  size,
  isPro = false,
  label = null,
}: Props): JSX.Element => {
  const rootClassName = classnames('Switch', className, {
    'Switch--size-default': size === SWITCH_SIZES.DEFAULT,
    'Switch--size-small': size === SWITCH_SIZES.SMALL,
    'Switch--pro': isPro,
    'Switch--free': !isPro,
  });

  const elementClassName = classnames(
    'Switch__Element',
    checked ? 'Switch__Element--on' : 'Switch__Element--off'
  );

  return (
    <div className={rootClassName}>
      {label && (
        <label htmlFor={id} className="Switch__Label">
          {label}
        </label>
      )}
      <button
        className={elementClassName}
        type="button"
        name={name}
        role="switch"
        aria-checked={checked}
        id={id}
        onClick={onChange}
      />
    </div>
  );
};

export default Switch;
